import { render, staticRenderFns } from "./EmergencyprocessGrid.vue?vue&type=template&id=b364fb84"
import script from "./EmergencyprocessGrid.vue?vue&type=script&lang=js"
export * from "./EmergencyprocessGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports